var _path, _path2, _circle, _path3, _ellipse, _path4, _path5, _path6, _path7, _circle2, _ellipse2, _path8, _path9, _path10, _path11, _circle3, _rect, _rect2, _rect3, _rect4, _path12, _rect5, _path13, _path14, _ellipse3, _rect6, _rect7, _path15, _path16, _ellipse4, _rect8, _ellipse5, _ellipse6, _rect9, _ellipse7, _ellipse8, _path17, _path18, _rect10, _rect11, _path19, _circle4, _rect12, _circle5, _path20, _circle6, _rect13, _rect14, _path21, _rect15, _rect16, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectPhones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 276,
    viewBox: "0 0 308 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.092 65.6516C196.092 87.6154 177.015 105.421 153.483 105.421C129.95 105.421 110.873 87.6154 110.873 65.6516C110.873 43.6877 129.95 25.8825 153.483 25.8825C177.015 25.8825 196.092 43.6877 196.092 65.6516Z",
    fill: "url(#paint0_linear_1809_13)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.011 17.0449H156.323V27.145H150.011V17.0449Z",
    fill: "url(#paint1_linear_1809_13)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 153.166,
    cy: 9.46941,
    r: 8.83757,
    fill: "#000F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.798 108.576C178.9 108.576 199.248 89.6403 199.248 66.2819C199.248 52.1589 191.81 39.6526 180.379 31.971C179.318 31.2578 178.056 30.915 176.777 30.915H130.819C129.54 30.915 128.279 31.2578 127.217 31.971C115.787 39.6526 108.348 52.1589 108.348 66.2819C108.348 89.6403 128.696 108.576 153.798 108.576Z",
    fill: "url(#paint2_linear_1809_13)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.456,
    cy: 93.4091,
    rx: 3.34201,
    ry: 6.26627,
    transform: "rotate(-44.9872 121.456 93.4091)",
    fill: "#236DC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.459 99.6419C130.172 97.9034 128.742 93.7172 125.265 90.2917C121.788 86.8662 117.581 85.4985 115.869 87.2369C114.156 88.9753 115.586 93.1616 119.063 96.5871C122.54 100.013 126.747 101.38 128.459 99.6419ZM125.472 97.413C126.562 96.3069 125.652 93.6432 123.44 91.4636C121.228 89.284 118.551 88.4137 117.461 89.5199C116.371 90.626 117.281 93.2897 119.493 95.4693C121.706 97.6489 124.383 98.5192 125.472 97.413Z",
    fill: "#468BDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.102 94.8791L126.054 92.3991L121.094 88.4944L119.142 90.9744L124.102 94.8791ZM114.181 99.5549L112.669 96.7841H112.669L114.181 99.5549ZM109.928 112.383C111.087 113.686 113.082 113.803 114.384 112.645C115.687 111.487 115.805 109.492 114.646 108.189L109.928 112.383ZM119.142 90.9744C117.147 93.5087 116.351 94.4241 115.694 94.9845C115.075 95.5128 114.597 95.7325 112.669 96.7841L115.692 102.326C117.236 101.484 118.532 100.862 119.793 99.7855C121.016 98.7415 122.204 97.2897 124.102 94.8791L119.142 90.9744ZM112.669 96.7841C109.805 98.3463 108.306 101.333 107.851 104.057C107.4 106.765 107.843 110.038 109.928 112.383L114.646 108.189C114.206 107.694 113.833 106.563 114.078 105.096C114.32 103.646 115.03 102.687 115.692 102.326L112.669 96.7841Z",
    fill: "#000F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.103 94.8791L126.055 92.3991L121.095 88.4944L119.143 90.9744L124.103 94.8791ZM115.445 98.9237L113.933 96.1528L115.445 98.9237ZM109.962 112.419C111.14 113.704 113.136 113.791 114.421 112.613C115.706 111.435 115.793 109.438 114.615 108.154L109.962 112.419ZM114.615 108.154C114.515 108.044 114.43 107.937 114.359 107.834L109.165 111.422C109.404 111.768 109.67 112.101 109.962 112.419L114.615 108.154ZM116.54 101.954C116.684 101.853 116.824 101.767 116.956 101.695L113.933 96.1528C113.584 96.3434 113.246 96.5544 112.921 96.7817L116.54 101.954ZM116.956 101.695C117.124 101.603 117.282 101.517 117.431 101.436L114.425 95.8858C114.273 95.9679 114.109 96.0568 113.933 96.1528L116.956 101.695ZM123.773 95.3003C123.878 95.165 123.988 95.0246 124.103 94.8791L119.143 90.9744C119.023 91.1264 118.908 91.2732 118.797 91.4149L123.773 95.3003Z",
    fill: "#0F4688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.2 94.1893C127.53 92.8927 126.534 91.5416 125.265 90.2917C123.298 88.3533 121.097 87.0739 119.246 86.6433L120.027 89.2587C121.109 89.61 122.333 90.3728 123.44 91.4636C124.328 92.3382 125.006 93.2907 125.429 94.1893H128.2Z",
    fill: "#468BDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.532,
    cy: 112.714,
    r: 6.70709,
    transform: "rotate(-30.6263 114.532 112.714)",
    fill: "#85B7F2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.34201,
    cy: 6.26627,
    rx: 3.34201,
    ry: 6.26627,
    transform: "matrix(-0.707265 -0.706949 -0.706949 0.707265 192.309 91.3398)",
    fill: "#236DC1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.509 99.6419C176.797 97.9034 178.227 93.7172 181.704 90.2917C185.18 86.8662 189.387 85.4985 191.1 87.2369C192.813 88.9753 191.383 93.1616 187.906 96.5871C184.429 100.013 180.222 101.38 178.509 99.6419ZM181.496 97.413C180.407 96.3069 181.317 93.6432 183.529 91.4636C185.741 89.284 188.418 88.4137 189.508 89.5199C190.598 90.626 189.688 93.2897 187.475 95.4693C185.263 97.6489 182.586 98.5192 181.496 97.413Z",
    fill: "#468BDC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.867 94.8791L180.914 92.3991L185.874 88.4944L187.827 90.9744L182.867 94.8791ZM194.666 102.711L197.49 101.301L194.666 102.711ZM191.104 111.954C189.486 112.602 187.649 111.814 187.001 110.196C186.354 108.577 187.141 106.741 188.76 106.093L191.104 111.954ZM187.827 90.9744C189.544 93.1563 191.156 94.4612 192.791 95.8397C194.405 97.1999 196.227 98.7706 197.49 101.301L191.843 104.121C191.215 102.864 190.323 102.015 188.723 100.666C187.144 99.3355 185.042 97.6421 182.867 94.8791L187.827 90.9744ZM197.49 101.301C198.305 102.934 198.599 104.665 198.111 106.351C197.639 107.981 196.572 109.093 195.612 109.813C193.905 111.094 191.377 111.845 191.104 111.954L188.76 106.093C189.035 105.983 189.378 105.864 189.628 105.776C189.914 105.675 190.193 105.575 190.475 105.462C191.062 105.227 191.517 104.994 191.824 104.763C192.127 104.536 192.085 104.465 192.048 104.595C191.994 104.782 192.131 104.698 191.843 104.121L197.49 101.301Z",
    fill: "#000F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M182.867 94.8791L180.915 92.3991L185.875 88.4944L187.827 90.9744L182.867 94.8791ZM194.036 101.633L196.859 100.222H196.859L194.036 101.633ZM190.883 112.034C189.22 112.558 187.447 111.636 186.923 109.974C186.398 108.312 187.32 106.539 188.982 106.014L190.883 112.034ZM188.982 106.014C189.182 105.951 189.372 105.889 189.554 105.827L191.577 111.807C191.352 111.883 191.121 111.958 190.883 112.034L188.982 106.014ZM191.469 103.572C191.391 103.406 191.306 103.231 191.212 103.043L196.859 100.222C196.971 100.446 197.079 100.669 197.183 100.89L191.469 103.572ZM191.212 103.043C191.129 102.876 191.045 102.726 190.962 102.588L196.362 99.3194C196.536 99.6068 196.702 99.9071 196.859 100.222L191.212 103.043ZM183.419 95.5589C183.236 95.3409 183.052 95.1145 182.867 94.8791L187.827 90.9744C187.972 91.1586 188.115 91.3339 188.255 91.5011L183.419 95.5589Z",
    fill: "#0F4688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.768 94.1893C179.439 92.8927 180.435 91.5416 181.704 90.2917C183.671 88.3533 185.872 87.0739 187.723 86.6433L186.942 89.2587C185.859 89.61 184.636 90.3728 183.529 91.4636C182.641 92.3382 181.963 93.2907 181.54 94.1893H178.768Z",
    fill: "#468BDC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.124,
    cy: 111.451,
    r: 6.70709,
    transform: "rotate(-30.6263 187.124 111.451)",
    fill: "#86B8F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 150.643,
    y: 91.5322,
    width: 0.946883,
    height: 6.62818,
    rx: 0.473441,
    fill: "#5998E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 156.324,
    y: 91.5322,
    width: 0.946883,
    height: 6.62818,
    rx: 0.473441,
    fill: "#5998E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 153.482,
    y: 89.6387,
    width: 0.946883,
    height: 11.3626,
    rx: 0.473441,
    fill: "#5998E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 117.337,
    y: 42.2941,
    width: 73.2256,
    height: 38.5066,
    rx: 19.2533,
    fill: "#000F20",
    stroke: "#458DDE",
    strokeWidth: 2.52502
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.113 61.8633C145.113 61.0344 144.95 60.2135 144.633 59.4476C144.316 58.6817 143.851 57.9859 143.264 57.3997C142.678 56.8135 141.982 56.3485 141.217 56.0313C140.451 55.7141 139.63 55.5508 138.801 55.5508C137.972 55.5508 137.151 55.7141 136.385 56.0313C135.619 56.3485 134.923 56.8135 134.337 57.3997C133.751 57.9859 133.286 58.6818 132.969 59.4476C132.652 60.2135 132.488 61.0344 132.488 61.8633",
    stroke: "#72B2FF",
    strokeWidth: 3.15628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 164.051,
    y: 58.707,
    width: 10.7313,
    height: 3.15628,
    rx: 1.57814,
    fill: "#72B2FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M183.303 122.465C203.187 129.724 201.294 144.874 194.665 165.39C189.363 181.803 206.133 192.429 215.181 195.69",
    stroke: "#103456",
    strokeWidth: 3.15628
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M178.995 130.188C176.944 129.851 174.367 128.762 173.334 128.26L178.844 112.086C179.968 112.319 182.674 113.03 184.505 114.015C186.793 115.245 186.629 119.702 185.527 122.937C184.425 126.172 181.559 130.61 178.995 130.188Z",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176.087,
    cy: 120.172,
    rx: 8.54322,
    ry: 2.99013,
    transform: "rotate(-71.1878 176.087 120.172)",
    fill: "#B9B9B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.068,
    y: 118.146,
    width: 1.70864,
    height: 1.57161,
    rx: 0.785807,
    transform: "rotate(-71.1878 176.068 118.146)",
    fill: "#FF9154"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 174.529,
    y: 122.733,
    width: 1.70864,
    height: 1.62674,
    rx: 0.813372,
    transform: "rotate(-71.1878 174.529 122.733)",
    fill: "#FF9154"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5625 167.282C115.128 165.073 109.131 152.764 110.71 138.245C111.972 126.63 117.548 122.463 120.178 121.832",
    stroke: "#103456",
    strokeWidth: 3.15628
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.201 112.656C121.089 111.785 123.833 111.242 124.97 111.078L129.476 127.56C128.414 127.998 125.775 128.926 123.707 129.137C121.122 129.401 118.76 125.619 117.858 122.322C116.957 119.026 116.842 113.743 119.201 112.656Z",
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 127.224,
    cy: 119.32,
    rx: 8.54322,
    ry: 2.99013,
    transform: "rotate(74.7097 127.224 119.32)",
    fill: "#B9B9B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 131.904,
    y: 114.498,
    width: 1.70864,
    height: 5.59193,
    transform: "rotate(74.7097 131.904 114.498)",
    fill: "#FF9154"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.735,
    cy: 116.797,
    rx: 0.854322,
    ry: 0.621325,
    transform: "rotate(74.7097 126.735 116.797)",
    fill: "#FF9154"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.13,
    cy: 115.322,
    rx: 0.854322,
    ry: 0.621325,
    transform: "rotate(74.7097 132.13 115.322)",
    fill: "#FF9154"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 133.258,
    y: 119.442,
    width: 1.70864,
    height: 5.59193,
    transform: "rotate(74.7097 133.258 119.442)",
    fill: "#FF9154"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 128.089,
    cy: 121.741,
    rx: 0.854322,
    ry: 0.621325,
    transform: "rotate(74.7097 128.089 121.741)",
    fill: "#FF9154"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.483,
    cy: 120.266,
    rx: 0.854322,
    ry: 0.621325,
    transform: "rotate(74.7097 133.483 120.266)",
    fill: "#FF9154"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8907 122.465L60.2094 120.256L58 121.834L65.2594 124.99L65.8907 122.465Z",
    fill: "#236BB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.627 267.023L70.9395 269.548L71.5708 268.285L66.5207 266.392L64.627 267.023Z",
    fill: "#236BB0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -0.783493,
    y: 2.55371,
    width: 65.7337,
    height: 135.652,
    rx: 8.41383,
    transform: "matrix(-0.883409 0.468603 0.468603 0.883409 63.0757 118.532)",
    fill: "#3E91E1",
    stroke: "#236BB0",
    strokeWidth: 3.77764
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -0.783493,
    y: 2.55371,
    width: 65.7337,
    height: 135.652,
    rx: 8.41383,
    transform: "matrix(-0.883409 0.468603 0.468603 0.883409 58.7359 116.818)",
    fill: "#96C7F7",
    stroke: "#3E91E1",
    strokeWidth: 3.77764
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7109 130.354L22.242 141.212L23.8709 144.283C24.7597 145.959 26.8385 146.597 28.514 145.708L42.9154 138.069C44.5909 137.18 45.2287 135.101 44.3399 133.425L42.7109 130.354Z",
    fill: "#3E91E1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.7159,
    cy: 197.698,
    r: 14.9043,
    transform: "rotate(-1.40313 67.7159 197.698)",
    fill: "#79B9F7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 62.7988,
    y: 182.91,
    width: 4.55409,
    height: 29.8086,
    transform: "rotate(-1.40313 62.7988 182.91)",
    fill: "#79B9F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.1632,
    cy: 197.809,
    r: 14.9043,
    transform: "rotate(-1.40313 63.1632 197.809)",
    fill: "#4095E8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1237 203.358L61.4407 196.947L63.2001 196.023L67.5223 201.048L63.1237 203.358Z",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.6276,
    cy: 195.165,
    r: 2.48405,
    transform: "rotate(-27.7046 61.6276 195.165)",
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 241.836,
    y: 120.191,
    width: 65.7337,
    height: 135.652,
    rx: 8.41383,
    transform: "rotate(16.7548 241.836 120.191)",
    fill: "#3E91E1",
    stroke: "#236BB0",
    strokeWidth: 3.77764
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 238.334,
    y: 119.136,
    width: 65.7337,
    height: 135.652,
    rx: 8.41383,
    transform: "rotate(16.7548 238.334 119.136)",
    fill: "#96C7F7",
    stroke: "#3E91E1",
    strokeWidth: 3.77764
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M258.166 127.087L280.353 133.766L279.351 137.095C278.804 138.911 276.888 139.94 275.072 139.394L259.462 134.694C257.646 134.147 256.617 132.232 257.164 130.416L258.166 127.087Z",
    fill: "#3E91E1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 219.527,
    y: 207.807,
    width: 51.1317,
    height: 1.89377,
    rx: 0.946883,
    transform: "rotate(17.1598 219.527 207.807)",
    fill: "#4095E8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 218.969,
    y: 209.616,
    width: 41.6628,
    height: 1.89377,
    rx: 0.946884,
    transform: "rotate(-72.8402 218.969 209.616)",
    fill: "#4095E8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M226.168 205.562L239.676 202.466L244.036 205.464L254.622 201.135L257.474 203.667L275.82 189.182",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.89377,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1809_13",
    x1: 153.483,
    y1: 17.0449,
    x2: 153.483,
    y2: 105.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1809_13",
    x1: 153.483,
    y1: 17.0449,
    x2: 153.483,
    y2: 105.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7E9DC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1809_13",
    x1: 153.798,
    y1: 23.9878,
    x2: 153.798,
    y2: 108.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83B5F1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectPhones);
export default __webpack_public_path__ + "static/media/connect_phones.69d98ceffb64dbd2ff9803e433ff9e2f.svg";
export { ForwardRef as ReactComponent };